import { SvgIcon, SvgIconProps, Tooltip } from "@mui/material"

export const HaufeIcon = (props: SvgIconProps) => {
  return (
    <Tooltip title="Diese Daten werden zur Angebotserstellung in Haufe übernommen.">
      <SvgIcon {...props} viewBox="0 12 25 24">
        <path
          d="M17.2187 21.1101L23.1579 13.4199H17.3684L14.324 17.3907L17.2187 21.1101Z"
          fill="#573393"
        />
        <path
          d="M0 35.7868H5.78947L11.9782 27.7951L14.9229 24.0757L9.08348 24.0254L0 35.7868Z"
          fill="#573393"
        />
        <path
          d="M16.5699 27.7949L14.324 30.7101L18.3167 35.7866H21.2115H24.1062L17.2686 26.9404L16.5699 27.7949Z"
          fill="#D822D1"
        />
        <path
          d="M9.08343 24.0253L14.9228 24.0756L6.7377 13.4199H0.898315L9.08343 24.0253Z"
          fill="#D822D1"
        />
      </SvgIcon>
    </Tooltip>
  )
}
